import DocBuilderContentModel, * as contentModels from "./contentmodel";

export const ContentModels = contentModels;
export const ContentModel = DocBuilderContentModel;

import "./style.css";

export const description =
  "Allows users to select items from a list and order them, so users are engaged in synthesis and analysis";
export const instructions = `Users should drag and drop items using their mouse.`;



// WEBPACK FOOTER //
// ./app_modules/document-builder-activity/src/index.js